"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomTwoMonthsHeader = exports.CustomHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _chevronLeft = require("../../../assets/icons/chevron-left.svg");
var _chevronRight = require("../../../assets/icons/chevron-right.svg");
var _calendarHeaderModule = _interopRequireDefault(require("./calendar-header.module.scss"));
var renderChevronLeft = function renderChevronLeft(decreaseMonth) {
  return /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Previous Month",
    type: "button",
    className: 'react-datepicker__navigation react-datepicker__navigation--previous',
    onClick: decreaseMonth
  }, /*#__PURE__*/_react.default.createElement(_chevronLeft.ReactComponent, {
    className: (0, _classnames.default)(_calendarHeaderModule.default['calendar-header__chevron'])
  }));
};
var renderChevronRight = function renderChevronRight(increaseMonth) {
  return /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Next Month",
    type: "button",
    className: 'react-datepicker__navigation react-datepicker__navigation--next',
    onClick: increaseMonth
  }, /*#__PURE__*/_react.default.createElement(_chevronRight.ReactComponent, {
    className: (0, _classnames.default)(_calendarHeaderModule.default['calendar-header__chevron'])
  }));
};
var renderMonthName = function renderMonthName(monthDate) {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "react-datepicker__current-month"
  }, monthDate.toLocaleString('en-US', {
    month: 'long',
    year: 'numeric'
  }));
};
var CustomHeader = function CustomHeader(_ref) {
  var monthDate = _ref.monthDate,
    decreaseMonth = _ref.decreaseMonth,
    increaseMonth = _ref.increaseMonth;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarHeaderModule.default['calendar-header']
  }, renderChevronLeft(decreaseMonth), renderMonthName(monthDate), renderChevronRight(increaseMonth));
};
exports.CustomHeader = CustomHeader;
var CustomTwoMonthsHeader = function CustomTwoMonthsHeader(_ref2) {
  var monthDate = _ref2.monthDate,
    customHeaderCount = _ref2.customHeaderCount,
    decreaseMonth = _ref2.decreaseMonth,
    increaseMonth = _ref2.increaseMonth;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarHeaderModule.default['calendar-header']
  }, customHeaderCount === 0 && renderChevronLeft(decreaseMonth), renderMonthName(monthDate), customHeaderCount === 1 && renderChevronRight(increaseMonth));
};
exports.CustomTwoMonthsHeader = CustomTwoMonthsHeader;